import { get } from '@/services/api';
import { apiUrls } from '@/constants/apiUrls';
import { QueryKeys } from '@/constants/queryKeys';
import { useQuery } from '@tanstack/react-query';

export const useNotification = () => {
  const notificationData = async () => {
    const response = await get(apiUrls.users.notifications);
    const data: any = response.data;
    return data;
  };

  const { data, isLoading, isSuccess, refetch } = useQuery({
    queryFn: notificationData,
    queryKey: [QueryKeys.NOTIFICATIONS],
    enabled: true,
  });

  return {
    notifications: data?.results ?? [],
    npsModal: data?.nps_modal,
    isLoading,
    isSuccess,
    refetch,
  };
};
